import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { api, staticpageUploadDir } from '../../config';
import cx from 'classnames';
import r from 'quill/dist/quill.snow.css';
import s from './Page.css';
import t from '../../styles/customQuillEditor.css'

function Page(props) {
  const { title, html, pageBanner, containerClass } = props;
  let addClass = 'ql-editor frontend';

  return (
    <div className={containerClass}>
      {pageBanner && (
        <div
          className={s.staticContentPageTopBgImg}
          style={{ backgroundImage: `url(${api.apiEndpoint + staticpageUploadDir + pageBanner})` }}
        />
      )}
      <div className={s.staticContentPageInfoContainer}>
        {title && <h1>{title}</h1>}
        <div dangerouslySetInnerHTML={{ __html: html }} className={addClass} />
      </div>
    </div>
  );
}

Page.propTypes = {
  title: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
  pageBanner: PropTypes.string,
  containerClass: PropTypes.string
};

export default withStyles(r, s, t)(Page);
